import * as ng from 'angular';

import './img-upload.controller';

const templateUrl = require('./img-upload.directive.html');

ng.module('e360')
   .directive('imgUpload', imgUploadDirective);

export function imgUploadDirective():ng.IDirective {
   return {
      templateUrl: templateUrl,
      restrict: 'EA',
      require: { ngModelCtrl: 'ngModel' },
      controller: 'ImgUploadController',
      controllerAs: 'ctrl',
      bindToController: true,
      scope: {
         default: '=?',
         width: '<',
         height: '<',
         scale: '<?'
      }
   };
}
